import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { actions as userActions } from '../../user/reducer';
import { selectBypassBusinessRules, selectUserName, showBBRToggle } from '../../user/selectors';
import CartLink from './CartLink';
import UserLocation from './UserLocation';

const RightDesktop: React.FC = () => {
  const dispatch = useDispatch();
  const userName = useSelector(selectUserName);
  const bypassBusinessRules = useSelector(selectBypassBusinessRules);
  const showToggle = useSelector(showBBRToggle);

  return (
    <StyledRightDesktop>
      <div className="user-location">
        <div className="user">
          {`${userName} `}(
          <button className="sign-out" onClick={() => dispatch(userActions.logoutUser())}>
            sign out
          </button>
          )
        </div>
        {showToggle && (
          <div className="bbr">
            Bypass Business Rules:{' '}
            <button onClick={() => dispatch(userActions.toggleBypassBusinessRules())}>
              {bypassBusinessRules ? 'On' : 'Off'}
            </button>
          </div>
        )}
        <UserLocation />
      </div>
      <CartLink />
    </StyledRightDesktop>
  );
};

const StyledRightDesktop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-right: 5px;

  & .user-location {
    font: ${(props) => props.theme.smallTextFont};
    color: ${(props) => props.theme.colors.text};
  }

  & .user {
    padding: 0 7px;
  }

  & .bbr {
    padding: 0 7px;

    button {
      cursor: pointer;
      font: ${(props) => props.theme.regularBoldFont};
      color: ${(props) => props.theme.colors.primary};
    }
  }

  & .sign-out {
    color: ${(props) => props.theme.colors.primary};
    border: none;
    background-color: ${(props) => props.theme.colors.background};
    padding: 2px;
  }

  & .sign-out:hover {
    cursor: pointer;
  }
`;

export default RightDesktop;
